import router from '@/router';
import store from '@/store/store';

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters['account/isAuthenticated'];
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !isAuthenticated) {
    next('inloggen');
  } else if (isAuthenticated && to.path === '/inloggen') {
    router.push('/');
  } else {
    next();
  }
});
